// Typelizer digest 70242af7b1d43d9c88a62a848cc19fc2
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../../runtime'
import { buildUrl } from '../../../runtime'

export default {
  /** POST /accountant/firm/staff */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/accountant/firm/staff', {}, options),
    method: 'post',
  }),

  /** DELETE /accountant/firm/staff/:id */
  destroy: (
    params: { id: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/accountant/firm/staff/:id', params, options),
    method: 'delete',
  }),
}
